<template>
  <b-col cols="12" :md="componentConfig.halfWidth === 'true' ? '6' : '12'" class="mb-5">
    <b-container class="box h-100">
      <b-row align-content="stretch">
        <div class="box w-100">
          <div class="py-3 text-center">
            <b-link @click.prevent="$root.$emit('bv::show::modal', 'video-modal')">
              <b-img :src="translatedConfig('videoImg')" class="mb-4" fluid />
            </b-link>
            <h2>{{ 'title' | translate(labels) }}</h2>
            <p>{{ 'subtitle' | translate(labels) }}</p>
            <b-button v-if="componentConfig.buttonLabel"
                      variant="primary"
                      size="lg"
                      class="font-condensed text-large"
                      @click.prevent="$root.$emit('bv::show::modal', 'video-modal')"
            >
              <b-icon icon="play" class="mr-2" />
              {{ 'buttonLabel' | translate(labels) }}
            </b-button>
          </div>
        </div>
      </b-row>

      <b-modal id="video-modal"
               size="xl"
               static
               centered
               hide-footer
               modal-class="modal-transparent"
               :lazy="false"
               @shown="playVideo"
               @hide="pauseVideo"
      >
        <b-embed ref="videoObject" type="video" controls>
          <source :src="translatedConfig('videoUrl')">
          {{ 'videoError' | translate(labels) }}
        </b-embed>
      </b-modal>
    </b-container>
  </b-col>
</template>

<script>
export default {
  data() {
    return {
      componentConfig: this.config
    }
  },
  methods: {
    pauseVideo() {
      const vid = this.$refs['videoObject'].querySelector('video')
      if (vid) vid.pause()
    },
    playVideo() {
      const vid = this.$refs['videoObject'].querySelector('video')
      if (vid) vid.play()
    }
  }
}
</script>

<style lang="scss" scoped>
#video-modal {
  video {
    outline: none;
  }
}
</style>
